import { motion } from 'framer-motion'
import { trackSubscribeClick } from '../utils/analytics'

const platforms = [
  {
    name: 'YouTube',
    url: 'https://youtube.com/@promptedthoughts',
    icon: '📺',
    color: '#ff006e',
    featured: true,
  },
  {
    name: 'Apple Podcasts',
    url: 'https://podcasts.apple.com',
    icon: '🎧',
    color: '#7c3aed',
  },
  {
    name: 'Spotify',
    url: 'https://open.spotify.com',
    icon: '🎵',
    color: '#00ff9f',
  },
  {
    name: 'Google Podcasts',
    url: 'https://podcasts.google.com',
    icon: '🎙️',
    color: '#00d4ff',
  },
  {
    name: 'RSS',
    url: '/feed.xml',
    icon: '📡',
    color: '#ff6b35',
  },
]

const BadgeRow = () => {
  const handleClick = (platformName) => {
    trackSubscribeClick(platformName)
  }

  return (
    <div className="flex flex-wrap gap-3 justify-center items-center">
      {platforms.map((platform, index) => (
        <motion.a
          key={platform.name}
          href={platform.url}
          target={platform.name !== 'RSS' ? '_blank' : undefined}
          rel={platform.name !== 'RSS' ? 'noopener noreferrer' : undefined}
          onClick={() => handleClick(platform.name)}
          className="group"
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.3, delay: index * 0.1 }}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          <div
            className={`flex items-center space-x-2 rounded-lg border-2 transition-all duration-200 font-mono ${
              platform.featured ? 'px-6 py-3' : 'px-4 py-2'
            }`}
            style={{
              borderColor: platform.color,
              backgroundColor: platform.featured ? 'rgba(255, 0, 110, 0.1)' : 'var(--color-bg-subtle)',
              boxShadow: `0 0 ${platform.featured ? '10px' : '6px'} ${platform.color}30`,
            }}
          >
            <span className={platform.featured ? 'text-3xl' : 'text-2xl'}>{platform.icon}</span>
            <span className={`font-bold text-off-white ${platform.featured ? 'text-base tracking-wider' : 'text-sm'}`} style={{ textTransform: 'uppercase', letterSpacing: '0.05em' }}>
              {platform.name}
            </span>
          </div>
        </motion.a>
      ))}
    </div>
  )
}

export default BadgeRow
